import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource, MatTreeModule } from '@angular/material/tree';
import { Component, Inject, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Params } from '@angular/router';
import { UMPCategory, Utils } from '../../../../../utils/utils';
import { SpinnerOverlayService } from '../../../../../services/spinner-overlay.service';
import { SaveService } from '../../../../../services/save.service';
import { DefaultValuesService } from '../../../../../services/defaultvalues.service';
import { MersyMassReleaseRevokeDto } from '../../../../../interfaces/mersymassreleaserevokedto';
import { MatDialog, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { Editgroupfunctionsdialogue } from './editgroupfunctionsdialogue/editgroupfunctionsdialogue.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { NgClass } from '@angular/common';

interface MGMTBranchNode {
    groupId: string;
    groupName: string;
    subGroupsAllowed: boolean,
    selected?: boolean;
    disabled?: boolean;
    indeterminate?: boolean;
    parent?: MGMTBranchNode;
    groups: MGMTBranchNode[];
    groupFunction: string;
    businessLevel: string;
    hierarchyType: string;
    isHistoric: boolean;
}

@Component({
    selector: "usermgmtbranch",
    templateUrl: './usermgmtbranch.component.html',
    styleUrls: ['./usermgmtbranch.component.less', '../../../../../style/new-generic-styles.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        MatTreeModule,
        MatDialogModule,
        MatButtonToggleModule,
        MatIconModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatButtonModule,
        FormsModule,
        NgClass
    ]
})

export class UserMgmtBranch implements OnInit {
    @Input() public groupmgmtcallback: Function | undefined;

    @Input() selBehaviour: string = 'Default';
    @Output() relrevokeParams = new EventEmitter<MersyMassReleaseRevokeDto>();

    selectorValue: string = 'All';
    hierarchyType: string = 'ACT';
    oplType: string = "BUDY"
    allToggelButtonOption = [];

    userId = '';
    public TREE_DATA: MGMTBranchNode[] = [];/*** */

    public selectedNodes: string[] = [];
    public unSelectedNodes: string[] = [];
    public selectedDistinctMgmtId: Set<string> = new Set<string>();


    public treeControl = new NestedTreeControl<MGMTBranchNode>((node) => node.groups);
    public dataSource = new MatTreeNestedDataSource<MGMTBranchNode>();
    public mersyMassRelRevParams: MersyMassReleaseRevokeDto = {} as MersyMassReleaseRevokeDto

    public searchString = '';
    public showOnlySelected = false;
    public branchLevel: string = 'MANAGEMENT';
    Tree_Response_State: number = -2; //0 -> empty , 1 -> correct and not empty ,-1 -> error, -2 -> Calling API
    showData: boolean = false;
    showEdit: boolean = false;
    showViewGroupFunctions: boolean = false;
    addgrpdialogRef: MatDialogRef<Editgroupfunctionsdialogue, any> | undefined
    mgmtHierarchyRef: MGMTHierarchyRefNode[] = [];

    isCallSucceed: number = 0;

    public accessControlList: MgmtBranchAccessControl[] = [];
    data: TreeManagement<UMPCategory> = {
        SelectedBranches: [],
        UnselectedBranches: [],
        UmpCategory: UMPCategory.MgmtBranchHierarchy
    }

    constructor(
        private toastrService: ToastrService,
        private route: ActivatedRoute,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private spinnerOverlayService: SpinnerOverlayService,
        private saveService: SaveService,
        public defaults: DefaultValuesService,
        private readonly dialogForm: MatDialog

    ) {
        this.route.params.subscribe(
            (params: Params) => {
                this.hideData();
            });
    }

    ngOnInit() {
        this.accessControlList = [
            { groupFunction: 'tax', businessLevel: 'pe', readOnlyAccess: !this.defaults.isMgmtHierarchyAdmin && !this.defaults.isMersyCDPTaxAdmin, adminAccess: this.defaults.isMgmtHierarchyAdmin || this.defaults.isMersyCDPTaxAdmin },
        ];
        if (this.isMassReleaseRevoke()) {
            this.setDefaultMassRelRevoke()
            this.resetAll()
        }      
    }

    setDefaultMassRelRevoke() {
        this.onhierarchyTypeToggle('ACT');
        this.onNodeGFToggle('All');
        this.onOPLTypeToggle('BUDY');
    }
    resetAll() {
        this.treeControl = new NestedTreeControl<MGMTBranchNode>((node) => node.groups);
        this.dataSource = new MatTreeNestedDataSource<MGMTBranchNode>();
        this.userId = this.route.snapshot.paramMap.get('userId') || '';
        this.showData = true;
        this.allToggelButtonOption = [];
        this.funcGetUserMgmtBranches();
    }

    private preselect() {
        this.unSelectedNodes = [] as string[];
        for (let i = 0; i < this.treeControl.dataNodes.length; i++) {
            if (this.selectedNodes.find(e => e === this.treeControl.dataNodes[i].groupId)) {
                this.itemToggle(true, this.treeControl.dataNodes[i]);
            }
            else
                this.unSelectedNodes.push(this.treeControl.dataNodes[i].groupId);
            if (this.treeControl.dataNodes[i].groups) {

                const alldecendents = this.treeControl.getDescendants(this.treeControl.dataNodes[i]);

                for (let j = 0; j < alldecendents.length; j++) {
                    if (this.selectedNodes.find(e => e === alldecendents[j].groupId)) {
                        this.itemToggle(true, alldecendents[j]);
                    }
                    else
                        this.unSelectedNodes.push(alldecendents[j].groupId);
                }
            }
        }

    }

    public hasChild = (_: number, node: MGMTBranchNode) =>
        !!node.groups && node.groups.length > 0;

    private setParent(node: MGMTBranchNode, parent: MGMTBranchNode | undefined) {
        if (node)
            node.parent = parent;
        if (node.groups) {
            node.groups.forEach((childNode) => {
                this.setParent(childNode, node);
            });
        }
    }

    private checkAllParents(node: MGMTBranchNode) {
        if (node.parent) {
            const descendants = this.treeControl.getDescendants(node.parent);
            node.parent.indeterminate = descendants.some((child) => child.selected);
            this.checkAllParents(node.parent);
        }
    }

    public itemToggle(checked: boolean, node: MGMTBranchNode, manualUpdate: boolean = false) {
        if (manualUpdate && !this.isMassReleaseRevoke()) {
            this.saveService.addListener(this)
            this.saveService.showSaveButton();
        }
        node.selected = checked;
        if (node.groups && checked) {
            node.indeterminate = false;
            this.itemUnselect(node);
        }
        if (node.groups) {
            this.itemDisable(checked, node);
        }
        if (manualUpdate) {
            this.trackManualBranchChange(checked, node);
        }
        if (this.isMassReleaseRevoke()) {
            this.emitMassReleaseUpdate(checked, node);
        }
        this.checkAllParents(node);
    }

    private trackManualBranchChange(checked: boolean, node: MGMTBranchNode) {
        if (checked) {
            this.data.UnselectedBranches = this.data.UnselectedBranches.filter(x => x !== node.groupId)
            if (this.unSelectedNodes.find(e => e === node.groupId))
                this.data.SelectedBranches.push(node.groupId);
        } else {
            this.data.SelectedBranches = this.data.SelectedBranches.filter(x => x !== node.groupId)
            if (this.selectedNodes.find(e => e === node.groupId))
                this.data.UnselectedBranches.push(node.groupId);
        }
    }

    private emitMassReleaseUpdate(checked: boolean, node: MGMTBranchNode) {
        this.updateMgmtIdNodesSet(checked, node)
        this.mersyMassRelRevParams.Mgmtids = Array.from(this.selectedDistinctMgmtId.values())
        this.relrevokeParams.emit(this.mersyMassRelRevParams);
    }

    private itemUnselect(node: MGMTBranchNode) {
        const descendants = this.treeControl.getDescendants(node);
        descendants.forEach(node => { node.selected ? this.data.UnselectedBranches.push(node.groupId) : null; node.indeterminate = false; node.selected = false });
    }

    private itemDisable(checked: boolean, node: MGMTBranchNode) {
        const descendants = this.treeControl.getDescendants(node);
        descendants.forEach(node => node.disabled = checked);
    }

    public onSave() {
        if (this.data.SelectedBranches.length > 0 || this.data.UnselectedBranches.length > 0) {
            this.spinnerOverlayService.setFalseskipInterceptor()
            Utils.httpPostTreeGroupsByType(
                this.http
                , this.baseUrl
                , this.data
                , this.userId
                , this
                , function (tthis: UserMgmtBranch, data: any) {
                    tthis.data.SelectedBranches = []
                    tthis.data.UnselectedBranches = []
                    tthis.spinnerOverlayService.setTrueskipInterceptor()
                    tthis.funcNotify();
                    tthis.funcGetUserMgmtBranches();
                    if (tthis.groupmgmtcallback)
                        tthis.groupmgmtcallback(data);
                }
            )
        }
    }

    public accessNotAllowed(node: MGMTBranchNode): boolean {
        // Hiding nodes with special keywords in thier names ++pbi/10245
        const restrictedGroupKeywords = ['NON_OP', 'NON-OP'];
        if (restrictedGroupKeywords.some(keyword => node.groupName.toLowerCase().includes(keyword.toLowerCase()))) {
            return true;
        }

        if (!node.groupFunction) {
            return false;
        }

        const access = this.accessControlList.find(ac => this.groupFuncExist(ac.groupFunction, node) || ac.businessLevel.toLowerCase() == node.businessLevel.toLowerCase());

        if (!access) {
            return false;
        }
        //disabling the node & descendents incase you donot have admin access. 
        if (!access.adminAccess) {
            node.disabled = true;
            const descendants = this.treeControl.getDescendants(node);
            descendants.forEach(node => node.disabled = true);
        }
        return !(access.readOnlyAccess || access.adminAccess);
    }

    private nodeNameMatchesSearch(node: MGMTBranchNode): boolean {
        return node.groupName.toLowerCase().includes(this.searchString.toLowerCase());
    }

    private hasSearchMatchingAncestor(node: MGMTBranchNode): boolean {
        let current = node.parent;
        while (current) {
            if (this.nodeNameMatchesSearch(current)) {
                return true;
            }
            current = current.parent;
        }
        return false;
    }

    public hideLeafNode(node: MGMTBranchNode): boolean {
        if (this.searchString !== ''
            && !this.nodeNameMatchesSearch(node)
            && !this.hasSearchMatchingAncestor(node)) {
            return true;
        }
        return this.shouldHideNodeByMode(node);
    }

    public hideLeafNodeselector(selVal, node: MGMTBranchNode): boolean {
        return !this.groupFuncExist(selVal, node)
            || this.shouldHideNodeByMode(node);
    }

    groupFuncExist(selVal, node: MGMTBranchNode) {
        if (node.groupFunction) {
            const groupFunction = node.groupFunction;
            // Check if namesString contains a "/"
            if (groupFunction.includes('/')) {
                // Split the namesString into an array using "/"
                const namesArray = groupFunction.split('/').map(name => name.trim().toLowerCase());

                // Check if the targetName is present in the array
                return namesArray.includes(selVal.toLowerCase());
            } else {
                // If there are no slashes, compare the namesString directly with targetName
                return groupFunction.trim().toLowerCase() === selVal.toLowerCase();
            }
        }
        return false
    }

    public hideParentNode(node: MGMTBranchNode): boolean {
        if (!this.searchString ||
            this.nodeNameMatchesSearch(node) ||
            this.hasSearchMatchingAncestor(node)) {
            return false
        }
        const descendants = this.treeControl.getDescendants(node)

        if (descendants.some((descendantNode) => this.nodeNameMatchesSearch(descendantNode))) {
            return false
        }

        return true
    }

    public hideParentNodeselector(selVal, node: MGMTBranchNode): boolean {

        if (!selVal || (node.groupFunction && node.groupFunction.toLowerCase().indexOf(selVal.toLowerCase()) !== -1)) {
            return false;
        }

        const descendants = this.treeControl.getDescendants(node);

        if (descendants.some((descendantNode) => descendantNode.groupFunction && this.groupFuncExist(selVal, descendantNode))) {
            return false;
        }

        return true;
    }

    funcGetUserMgmtBranches() {
        this.Tree_Response_State = -2;
        this.treeControl.dataNodes = [];
        this.TREE_DATA.splice(0, this.TREE_DATA.length)
        this.showEdit = false;
        this.showViewGroupFunctions = false;
        Utils.httpGetUserMgmtBranches(
            this.http
            , this.baseUrl
            , this.userId
            , this
            , (tthis: UserMgmtBranch, data: any) => {
                tthis.allToggelButtonOption = data.groupFunctions;
                tthis.TREE_DATA = data.treeView; ///******** */
                tthis.treeControl.dataNodes = tthis.TREE_DATA;
                tthis.dataSource.data = tthis.TREE_DATA;
                tthis.selectedNodes = data.excludedPersonae;
                tthis.mgmtHierarchyRef = data.mgmtHierarchyRef;
                Object.keys(tthis.dataSource.data).forEach((key) => {
                    tthis.setParent(tthis.dataSource.data[key], undefined);

                }
                )
                if (tthis.selBehaviour == 'Default') {
                    tthis.preselect();
                }
                this.showEdit = this.defaults.isMgmtHierarchyAdmin;
                this.showViewGroupFunctions = this.defaults.isMersyAdminUser && !this.defaults.isMgmtHierarchyAdmin;
            });
    }

    funcNotify() {
        if (this.isCallSucceed === 1) {
            this.toastrService.success('Update Management Branch Hierarchy request sent successfully !', 'Update Management Branch Hierarchy Request!');
        }
        else if (this.isCallSucceed === -1) {
            this.toastrService.error('Update Management Branch Hierarchy request not sent successfully !', 'Update Management Branch Hierarchy Request!');
        }
    }

    isEditAllowed(node: MGMTBranchNode): boolean {
        return this.defaults.isMgmtHierarchyAdmin
            || (node.businessLevel === 'PE' && this.defaults.isMersyCDPTaxAdmin); // Just TAX Admin users are allowed to assign their branches. Otherwise, super admin user should assign them
    }

    editGroupFunctions() {
        this.openEditGroupFunctionDialogue();
    }

    public isHierarchyTypeSelected(node: MGMTBranchNode) {
        return node.hierarchyType === 'ALL' || node.hierarchyType === this.hierarchyType;
    }

    public selectAllPossiblePENodesTAX() {
        const allNodes = this.treeControl.dataNodes.reduce((acc, node) => {
            return acc.concat(node, this.treeControl.getDescendants(node));
        }, [] as MGMTBranchNode[]);

        allNodes.forEach(node => {
            if (node.businessLevel === 'PE' &&
                this.groupFuncExist('tax', node) &&
                !node.selected &&
                !this.hasSelectedAncestor(node) &&
                this.isEditAllowed(node)) {
                this.itemToggle(true, node, true);
            }
        });
    }

    hideData() {
        this.showData = false;
        this.allToggelButtonOption = [];
        this.TREE_DATA = [];
        this.treeControl.dataNodes = [];
        this.dataSource.data = [];
        this.selectedNodes = [];
    }

    private hasSelectedAncestor(node: MGMTBranchNode): boolean {
        let currentNode = node.parent;
        while (currentNode) {
            if (currentNode.selected) {
                return true;
            }
            currentNode = currentNode.parent;
        }
        return false;
    }

    //Mass Release Revoke related 
    public isMassReleaseRevoke(): boolean {
        return this.selBehaviour == 'MassReleaseRevoke'
    }

    private shouldHideNodeByMode(node: MGMTBranchNode): boolean {
        if (!this.isMassReleaseRevoke()) {
            return false;
        }
        return !this.isNodeRelevantForMassRelease(node);
    }

    private isNodeRelevantForMassRelease(node: MGMTBranchNode): boolean {
        switch (this.branchLevel) {
            case 'MANAGEMENT':
                return this.isMgmtNode(node);
            case 'FIELDBRANCH':
                return node.businessLevel === 'FIELDBRANCH';
            case 'BOTH':
                return this.isMgmtNode(node) || node.businessLevel === 'FIELDBRANCH';
            default:
                return this.isMgmtNode(node);
        }
    }

    private updateMgmtIdNodesSet(checked: boolean, node: MGMTBranchNode) {
        if (this.isNodeRelevantForMassRelease(node)) {
            this.updateSelectedMgmtIds(checked, node);
        }
        const descendants = this.treeControl.getDescendants(node);
        const relevantNodes = descendants.filter(n => this.isNodeRelevantForMassRelease(n));
        relevantNodes.forEach(n => this.updateSelectedMgmtIds(checked, n));
    }

    private updateSelectedMgmtIds(checked: boolean, node: MGMTBranchNode) {
        const nodeMgmtId = node.groupName.split('-').map(s => s.trim())[1];
        if (checked) {
            this.selectedDistinctMgmtId.add(nodeMgmtId);
        } else {
            this.selectedDistinctMgmtId.delete(nodeMgmtId);
        }
    }

    private isMgmtNode(node: MGMTBranchNode): boolean {
        return node.businessLevel === 'MANAGEMENT';
    }

    public onNodeGFToggle(NodeGF: string) {
        this.mersyMassRelRevParams.NodeGF = NodeGF
        this.relrevokeParams.emit(this.mersyMassRelRevParams);
    }

    public onhierarchyTypeToggle(hierarchyType: string) {
        this.mersyMassRelRevParams.HierarchyType = hierarchyType;
        this.relrevokeParams.emit(this.mersyMassRelRevParams);
    }

    public onOPLTypeToggle(oplType: string) {
        this.mersyMassRelRevParams.OPLType = oplType;
        this.relrevokeParams.emit(this.mersyMassRelRevParams);
    }

    public onBranchLevelToggle(level: string) {
        this.branchLevel = level;
        this.recalculateSelectedBranches();
    }

    private recalculateSelectedBranches() {
        this.selectedDistinctMgmtId.clear();
        const allNodes = this.treeControl.dataNodes.reduce((acc, node) => {
            return acc.concat(node, this.treeControl.getDescendants(node));
        }, [] as MGMTBranchNode[]);

        allNodes.filter(n => n.selected).forEach(n => {
            if (this.isNodeRelevantForMassRelease(n))
                this.updateSelectedMgmtIds(true, n);

            const descendants = this.treeControl.getDescendants(n);
            descendants.filter(d => this.isNodeRelevantForMassRelease(d))
                .forEach(d => this.updateSelectedMgmtIds(true, d));
        });

        this.mersyMassRelRevParams.Mgmtids = Array.from(this.selectedDistinctMgmtId.values());
        this.relrevokeParams.emit(this.mersyMassRelRevParams);
    }

    private openEditGroupFunctionDialogue() {
        this.addgrpdialogRef = this.dialogForm.open(Editgroupfunctionsdialogue, {
            height: '540px',
            width: '700px',
            disableClose: true,
            autoFocus: false,
            data: {
                availableGroupFunctions: this.allToggelButtonOption,
                mgmtGroupFunctionsInfo: this.mgmtHierarchyRef,
                isReadOnly: this.showViewGroupFunctions
            }
        });
        this.addgrpdialogRef.afterClosed().subscribe(result => {
            if (!result) {
                return;
            }
            if (result.success) {
                this.toastrService.success('GroupFunctions saved successfully!');
                this.resetAll();
            } else {
                this.toastrService.error(result?.errorMssg ?? 'Changes could not be saved');
            }
        });
    }
}